import { render, staticRenderFns } from "./AnalyticsCongratulation.vue?vue&type=template&id=1271bec4"
import script from "./AnalyticsCongratulation.vue?vue&type=script&lang=js"
export * from "./AnalyticsCongratulation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports